export function getSurveyResponses(aPatientId, aSurveyVersionCollectionId, aLimit, aOffset, aIncludeDeleted = false, aCompleted = true){
  let query = `
    query getSurveyResponsePage ($company_id: ID!, $user_id: ID!, $survey_id: ID, $survey_version_collection_id: ID, $offset: Int, $limit: Int, $include_deleted: Boolean, $completed: Boolean) {
      survey_response_page (company_id: $company_id, user_id: $user_id, survey_id: $survey_id, survey_version_collection_id: $survey_version_collection_id, offset: $offset, limit: $limit, include_deleted: $include_deleted, completed: $completed){
        survey_responses {
          id
          admin_id
          complete
          progress
          admin_name
          created_at
          lock_state
          updated_at
          completed_at
          completed_by_admin
          survey {
            id
            name
          }
          important_questions {
            key
            label
            survey_response_detail_value
          }
        }
        total
      }
    }
  `;
  let variables = {};
  
  return (dispatch, getState) => {
    let state = getState();
    variables['company_id'] = state.company && state.company.company && state.company.company.id;
    variables['user_id'] = aPatientId;
    variables['limit'] = aLimit;
    variables['offset'] = aOffset;
    variables['completed'] = aCompleted;
    variables['include_deleted'] = aIncludeDeleted;
    variables['survey_version_collection_id'] = aSurveyVersionCollectionId;
    return global.api.post("/queries", { query, variables });
  };
}
